// components/Comments/CommentList.jsx
import { Box } from '@mui/material';
import CommentItem from './CommentItem';

const CommentList = ({ comments, postAuthorId,
  onUpdate, onDelete, onReply, onReport, onLike }) => {
  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 1.5, sm: 2 },         // 댓글 간 간격 반응형
        px: { xs: 0.5, sm: 1 },          // 모바일에서는 여백 최소화
        maxWidth: '100%',               // 뷰포트 넘지 않게
      }}
    >
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          postAuthorId={postAuthorId}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onReply={onReply}
          onReport={onReport}
          onLike={onLike}
        />
      ))}
    </Box>
  );
};

export default CommentList;
